import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useNotify, useDataProvider, Title } from 'react-admin';
import { Card, CardContent, Typography, Button, Box } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const ProvenanceUpload = () => {
    const [file, setFile] = useState(null);
    const { id } = useParams();
    const navigate = useNavigate();
    const notify = useNotify();
    const dataProvider = useDataProvider();

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleUpload = async () => {
        if (!file) {
            notify('Please select a file', 'warning');
            return;
        }

        const formData = new FormData();
        formData.append('file', file);

        try {
            await dataProvider.create('provenance/upload', { id, data: formData });
            notify('CSV file uploaded successfully', 'success');
            navigate('/provenance');
        } catch (error) {
            notify('Error uploading CSV file', 'error');
        }
    };

    return (
        <Card>
            <Title title="Upload CSV for Provenance" />
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Upload provenance records for provenance: {id}
                </Typography>
                <Box mt={2}>
                    <input
                        accept=".csv"
                        style={{ display: 'none' }}
                        id="csv-file-upload"
                        type="file"
                        onChange={handleFileChange}
                    />
                    <label htmlFor="csv-file-upload">
                        <Button
                            variant="contained"
                            component="span"
                            startIcon={<CloudUploadIcon />}
                        >
                            Select CSV File
                        </Button>
                    </label>
                    {file && (
                        <Typography variant="body2" mt={1}>
                            Selected file: {file.name}
                        </Typography>
                    )}
                </Box>
                <Box mt={2}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleUpload}
                        disabled={!file}
                    >
                        Upload CSV
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
};

export default ProvenanceUpload;